let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e1Ceu")).then(() => parcelRequire('fsQEt'));